import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Divider, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
import { updateDomain } from '../../store/domainSlice';
import { fetchYoutubes, generateYoutube, setYoutubeActiveStatus, updateYoutube } from '../../store/cookieSlice';
import { toast } from 'react-toastify';
import CryptoJS from "crypto-js";
import PasswordVisibility from '../Common/PasswordVisibility';
import { decryptValue, encrypt } from '../../utils/helper';

export default function YoutubeForm({ page, setPage, getYoutubeAccounts, title, youtubeModal, setYoutubeModal, selectedDomain = null, selecteYoutube = null }) {
    const dispatch = useDispatch();
console.log("selecteYoutube- iinnn--",selecteYoutube);

    // const encrypt = (text) => {
    //     const encrypted = CryptoJS.AES.encrypt(text, process.env.REACT_APP_ENCRPTION_SECRET_KEY).toString();
    //     return encrypted;
    // };
    // const decryptValue = (encrypted, key) => {
    //     if (!key) throw new Error("Decryption key is missing");
    //     try {
    //         const bytes = CryptoJS.AES.decrypt(encrypted, key);
    //         const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    //         return decrypted || "";
    //     } catch (e) {
    //         return "";
    //     }
    // };

    const validationSchema = Yup.object({
        app_name: Yup.string().required("App Name is required"),
        api_key: Yup.string().required("API Key is required"),
    });

    const formik = useFormik({
        initialValues: {
            app_name: "",
            api_key: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setYoutubeModal(false);
            const toastId = toast.loading("We're processing the YouTube credentials. This may take a few moments");
            try {
                let apiKeyEncrypted = encrypt(values.api_key);
                if (selecteYoutube && selecteYoutube.id) {
                    // Edit
                    const data = { ...values, api_key: apiKeyEncrypted, integration: "youtube", id: selecteYoutube.uuid };
                    await dispatch(updateYoutube(data)).then(() => {
                        dispatch(fetchYoutubes());
                    })
                } else {
                    // Create
                    const data = { ...values, api_key: apiKeyEncrypted, integration: "youtube" };
                    await dispatch(generateYoutube(data)).then(() => {
                        dispatch(fetchYoutubes());
                    })
                }
                toast.success("Action completed successfully", { toastId });
            } catch (error) {
                toast.error("Something went wrong. Please try again.", { toastId });
            } finally {
                toast.dismiss(toastId);
            }
        }
    })

    const [showApiKey, setShowApiKey] = React.useState(false);

    useEffect(() => {
        if (youtubeModal) {
            if (selecteYoutube) {
                // Decrypt apiKey for editing
                const decryptedApiKey = decryptValue(selecteYoutube.api_key);
                formik.setValues({
                    app_name: selecteYoutube.app_name || "",
                    api_key: decryptedApiKey || ""
                });
            } else {
                formik.resetForm();
            }
        }
    }, [youtubeModal, selecteYoutube]);

    return (
        <CommentDrawer open={youtubeModal} setOpen={setYoutubeModal}>
            <Box className="p-3 position-relative h-100">
                <form onSubmit={formik.handleSubmit}>
                    <Typography variant="h6" gutterBottom>
                        {title}
                    </Typography>
                    <Divider />
                    <TextField
                        fullWidth
                        required
                        id="app_name"
                        name="app_name"
                        label="YouTube App Name"
                        margin="normal"
                        variant="outlined"
                        placeholder="Enter YouTube App Name"
                        value={formik.values.app_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.app_name && Boolean(formik.errors.app_name)}
                        helperText={formik.touched.app_name && formik.errors.app_name}
                    />
                    <TextField
                        fullWidth
                        required
                        id="api_key"
                        name="api_key"
                        label="YouTube API Key"
                        margin="normal"
                        variant="outlined"
                        placeholder="Enter YouTube API Key"
                        value={formik.values.api_key}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.api_key && Boolean(formik.errors.api_key)}
                        helperText={formik.touched.api_key && formik.errors.api_key}
                        type={showApiKey ? "text" : "password"}
                        InputProps={{
                            endAdornment: (
                                <PasswordVisibility
                                    showPassword={showApiKey}
                                    onToggle={() => setShowApiKey((prev) => !prev)}
                                />
                            )
                        }}
                    />
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setYoutubeModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={formik.isSubmitting || !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}